import { Box, Stack, Tooltip } from '@mui/material';
import { ReactElement } from 'react';

import { PaloCardCompany, PaloCardKind, PaloContactName } from './palo-contact-card';

/**
 * A list cell for a field that can hold several names.
 *
 * Written out one per line, a single inquiry with fifteen customers made its
 * row 313 pixels tall beside 39-pixel neighbours. The first name carries the
 * row, the rest are a count, and the whole list stays reachable in the tooltip.
 */
export const PaloNameListCell = ({
    names,
    companies,
    kind,
}: {
    names: (string | undefined)[];
    /**
     * The companies behind the names, in the same order. Where exactly one is
     * named, the cell carries its contact card (LST-S13); several names keep
     * the list in the tooltip, which the card would otherwise displace.
     */
    companies?: (PaloCardCompany | undefined)[];
    kind?: PaloCardKind;
}): ReactElement | null => {
    const present = names.filter((name): name is string => undefined !== name && '' !== name);

    if (0 === present.length) {
        return null;
    }

    if (1 === present.length && companies?.[0]) {
        return <PaloContactName company={companies[0]} kind={kind} />;
    }

    return (
        <Tooltip title={present.length > 1 ? present.join(', ') : ''}>
            <Stack direction="row" gap={0.75} alignItems="baseline">
                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{present[0]}</Box>
                {present.length > 1 && (
                    <Box sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>+{present.length - 1}</Box>
                )}
            </Stack>
        </Tooltip>
    );
};
